import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { differenceInDays, format } from 'date-fns';
import { computed } from 'vue';
import { declOfNum } from '@/shared/lib/utils/numberFormatters';
import { toDate } from '@/shared/lib/utils/toDate';
export default /*#__PURE__*/_defineComponent({
  __name: 'DaysToDateOutput',
  props: {
    input: null,
    withEndDate: {
      type: Boolean,
      default: false
    },
    empty: {
      default: 'Неизвестно'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var daysTitles = ['день', 'дня', 'дней'];
    var output = computed(function () {
      if (!props.input) {
        return props.empty;
      }
      var untilDate = toDate(props.input);
      if (!untilDate) {
        return props.empty;
      }
      var now = new Date();
      if (untilDate <= now) {
        return props.empty;
      }
      var days = Math.abs(differenceInDays(untilDate, now));
      if (props.withEndDate) {
        var date = format(untilDate, 'dd.MM.yyyy');
        return "".concat(days, " ").concat(declOfNum(days, daysTitles), " \u0434\u043E ").concat(date);
      }
      return "".concat(days, " ").concat(declOfNum(days, daysTitles));
    });
    return {
      __sfc: true,
      props: props,
      daysTitles: daysTitles,
      output: output
    };
  }
});